import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Image, Icon, Header, Label, Sidebar, Button, Table, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import { formatPrice } from '../../../helpers/format';
import { fetchLoyaltyProgramCampaigns, closeCampaign, setEditedEntity, confirm } from '../../../actions';
import CampaignEditor from './CampaignEditor';

class Campaigns extends Component {

    constructor(props) {
        super(props);

        this.renderCreationButton = this.renderCreationButton.bind(this);
        this.handleCloseCampaign = this.handleCloseCampaign.bind(this);
    }

    componentWillMount() {
        if (this.props.loyaltyProgram && this.props.loyaltyProgram.id) {
            this.props.fetchLoyaltyProgramCampaigns(this.props.loyaltyProgram.id);
        }
    }

    handleCloseCampaign(campaign) {
        const { confirm, closeCampaign, loyaltyProgram } = this.props;
        confirm({
            title: i18next.t('closeTitle'),
            message: i18next.t('closeMessage', { name: campaign.name }),
            onConfirm: () => closeCampaign(loyaltyProgram.id, campaign.id)
        });
    }

    renderCreationButton() {
        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                primary
                onClick={() => setEditedEntity('campaign')}
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { loyaltyProgram, campaigns, closeCampaign, history, onEdit, setEditedEntity } = this.props;
       
        if (!loyaltyProgram) return null;

        const columns = [{
            Header: '#',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            accessor: 'id'
        }, {
            Header: i18next.t('name'),
            accessor: 'name',
            filterable: true
        }, {
            Header: i18next.t('description'),
            accessor: 'description',
            filterable: true
        }, {
            Header: i18next.t('createDate'),
            accessor: 'createdAt',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date()
        }, {
            Header: i18next.t('closeTime'),
            accessor: 'closeDate',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date()
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            maxWidth: 120,
            sortable: false,
            filterable: false,
            Cell: row => {
                const campaign = row.original;

                return (
                    <div>
                        <Button
                            circular
                            size='tiny'
                            icon='find'
                            primary
                            onClick={() => history.push(`/loyaltyProgram/${loyaltyProgram.id}/campaigns/${campaign.id}`)}
                        />
                        {
                            campaign.closeDate ?
                                null
                                :
                                [
                                    <Button key="btn1" circular size='tiny' icon='pencil' onClick={() => setEditedEntity('campaign', campaign)} />,
                                    <Button key="btn2" circular size='tiny' icon='calendar times' negative onClick={() => this.handleCloseCampaign(campaign)} />
                                ]
                        }
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('loyaltyProgram.campaigns')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <CampaignEditor loyaltyProgramId={loyaltyProgram.id} />
                </SideEditor>
                <DataGrid
                    data={campaigns}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        if (typeof rowInfo !== "undefined" && rowInfo.original.closeDate) {
                            return { className: 'pi-data-grid-row-warning' };
                        }
                        return {};
                    }}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />
            </div>
        );
    }
}

Campaigns.propTypes = {
    fetchLoyaltyProgramCampaigns: PropTypes.func,
    closeCampaign: PropTypes.func,
    loyaltyProgram: PropTypes.object,
    campaigns: PropTypes.array,
    history: PropTypes.object,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    confirm: PropTypes.func,
    
};

function mapStateToProps(state) {
    const { campaigns } = state.loyaltyApp;
    const onEdit = state.editor.type === 'campaign';

    return { campaigns, onEdit };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramCampaigns,
    closeCampaign,
    setEditedEntity,
    confirm
})(Campaigns);
